// extracted by css-extract-rspack-plugin
export default {"sessionBar":"sessionBar-inpRCm","sessionBarButton":"sessionBarButton-Eo5Vwt","newChatButton":"newChatButton-_IlXQw","historyDropdownTrigger":"historyDropdownTrigger-lySPjD"};